const dictionary = {
  en: () => import("./dictionary/en.json").then((r) => r.default),
  pg: () => import("./dictionary/pg.json").then((r) => r.default),
  fr: () => import("./dictionary/fr.json").then((r) => r.default),
};

export const getDictionary = (lang) => {
  // fallback safety
  if (!dictionary[lang]) {
    return dictionary["pg"]();
  }
  return dictionary[lang]();
};
